import { Badge, Button, createTheme } from '@mantine/core';
import { colors, spacings, fontSize, breakpoints } from './theme';

const button = Button.extend({
  defaultProps: {
    variant: 'gradient',
    // Align icon vertically with text
    styles: { section: { marginBottom: 4, height: 20, width: 20 } },
  },
});

const badge = Badge.extend({
  // Avoid uppercase in badge
  defaultProps: { styles: { label: { textTransform: 'none' } } },
});

const mantineTheme = createTheme({
  colors,
  components: { Button: button, Badge: badge },
  spacing: spacings,
  fontSizes: fontSize,
  breakpoints: breakpoints,
  primaryColor: 'primary',
  defaultGradient: {
    from: 'primary.5',
    to: 'primary.7',
    deg: 45,
  },
});

export type ColorsType = keyof typeof colors;

export default mantineTheme;
